export default "__VITE_ASSET__BYMRvh3E__"